import { NgFor } from "@angular/common";
import { Component, inject } from "@angular/core";
import { AreaHeaderComponent } from "@odx/angular/components/area-header";
import { ButtonComponent } from "@odx/angular/components/button";
import { ModalContentDirective, ModalFooterComponent, ModalHeaderComponent, ModalRef } from "@odx/angular/components/modal";
import { UploadErrorModalData } from "@utils/upload-error-mapper";

@Component({
  selector: "app-floorplan-upload-error-modal",
  imports: [AreaHeaderComponent, ButtonComponent, ModalContentDirective, ModalFooterComponent, ModalHeaderComponent, NgFor],
  templateUrl: "./floorplan-upload-error-modal.component.html",
  styleUrl: "./floorplan-upload-error-modal.component.scss",
  standalone: true,
})
export class FloorplanUploadErrorModalComponent {
  public readonly modalRef = inject(ModalRef<any, UploadErrorModalData>);

  onConfirm() {
    this.modalRef.close(true);
  }
}
